import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import TextMaskInput from "./TextMaskInput";

function PhoneNumberField(props) {
  const {
    inputRef,
    inputProps,
    InputLabelProps,
    InputProps,
    onChange,
    value,
    name,
    ...other
  } = props;

  return (
    <TextField
      InputLabelProps={{
        ...InputLabelProps,
      }}
      InputProps={{
        onChange: (event) => {
          // Set the value to be '' if there are no digits (this'll exclude any mask
          // characters). This way, required fields are validated
          const digits = event.target.value.replace(/\D+/g, "");
          // send unformatted string as payload value and keep formatted string for display
          return onChange({target: {value: digits || "", name}});
        },
        // Custom logic for handling a bug in react-text-mask where pressing the backspace key on
        // a non-digit charater won't remove the placeholder character and move back one position.
        // From: https://github.com/text-mask/text-mask/issues/230#issuecomment-381350161
        onKeyDown: (event) => {
          const keyCode = Number(event.keyCode);
          const selectedCharacter = event.target.value
            .substr(event.target.selectionStart - 1, 1)
            .trim();

          // Do work only on backspace key for non-numeric characters
          if (
            (!selectedCharacter || isNaN(selectedCharacter)) &&
            keyCode === 8
          ) {
            // Disable text mask events for these cursor positions
            event.preventDefault();

            // Only keep the digits in the value (keep 9999999999, instead of (999) 999-9999)
            event.target.value = event.target.value || "";
            event.target.value = event.target.value.replace(/\D+/g, "");

            // Simulate backspace delete
            event.target.value = event.target.value.substring(
              0,
              event.target.value.length - 1
            );

            // Send event with new value
            if (onChange) {
              onChange(event);
            }
          }
        },
        value,
        inputComponent: TextMaskInput,
        // Workaround for eslint issue eslint(react/jsx-no-duplicate-props)
        // https://github.com/mui-org/material-ui/issues/10064#issuecomment-373190215
        inputProps: {
          mask: [
            "(",
            /[1-9]/,
            /\d/,
            /\d/,
            ")",
            " ",
            /\d/,
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
          ],
          ...inputProps,
        },
        ...InputProps,
      }}
      {...other}
    />
  );
}
TextMaskInput.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export default PhoneNumberField;



// WEBPACK FOOTER //
// ./src/components/Forms/PhoneNumberField.jsx